import { render, staticRenderFns } from "./ItemTermComponent.vue?vue&type=template&id=0775de54"
import script from "./ItemTermComponent.vue?vue&type=script&lang=js"
export * from "./ItemTermComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0775de54')) {
      api.createRecord('0775de54', component.options)
    } else {
      api.reload('0775de54', component.options)
    }
    module.hot.accept("./ItemTermComponent.vue?vue&type=template&id=0775de54", function () {
      api.rerender('0775de54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/principal_search/components/ItemTermComponent.vue"
export default component.exports